/**
 * ממיר handleFeeData (% או +) לסכום עמלה אבסולוטי בש״ח.
 * בסיס לאחוזים: priceWithCommission (כולל מרווח HR), לא כבודה.
 */

function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function round2(n) {
  return Math.round(Number(n) * 100) / 100;
}

/**
 * @param {object|null|undefined} ourPrice
 * @param {{ columnHandlingFee?: unknown }} [opts]
 * @returns {number}
 */
export function resolveAbsoluteAgentHandlingFeeIls(ourPrice, opts = {}) {
  const op = ourPrice && typeof ourPrice === "object" ? ourPrice : {};
  const tf =
    op.ourTotalFare && typeof op.ourTotalFare === "object" ? op.ourTotalFare : {};
  const hfd =
    op.handleFeeData && typeof op.handleFeeData === "object"
      ? op.handleFeeData
      : null;
  const feeType = String(hfd?.type || "+").trim();
  const feeValue = num(hfd?.value);
  const pwc = num(op.priceWithCommission) ?? num(tf.priceWithCommission) ?? 0;
  const absFromOurPrice =
    num(tf.handleFee) ?? num(op.handleFee) ?? num(op.handling_fee);
  const absFromColumn = num(opts.columnHandlingFee);

  if (feeType === "%" && feeValue != null && feeValue > 0) {
    const candidates = [absFromOurPrice, absFromColumn].filter(
      (v) => v != null && v > 0 && Math.abs(v - feeValue) > 0.02
    );
    if (candidates.length > 0) {
      return round2(candidates[0]);
    }
    if (pwc > 0) {
      return round2((pwc * feeValue) / 100);
    }
    return 0;
  }

  if (absFromColumn != null && absFromColumn > 0) {
    return round2(absFromColumn);
  }
  if (absFromOurPrice != null && absFromOurPrice > 0) {
    return round2(absFromOurPrice);
  }
  if (feeType === "+" && feeValue != null && feeValue > 0) {
    return round2(feeValue);
  }
  return 0;
}

/**
 * חלק הסוכן בארנק = handling_fee_abs × walletCommissionPercent / 100.
 * @param {object|null|undefined} order
 * @returns {number|null}
 */
export function resolveLdsWalletCommissionIlsFromOrder(order) {
  if (!order || typeof order !== "object") return null;
  const opRaw = order.ourprice || order.ourPrice;
  const op = opRaw && typeof opRaw === "object" ? opRaw : {};
  const tf =
    op.ourTotalFare && typeof op.ourTotalFare === "object" ? op.ourTotalFare : {};
  const absoluteHf = resolveAbsoluteAgentHandlingFeeIls(op, {
    columnHandlingFee: order.handlingfee ?? order.handling_fee,
  });
  if (!(absoluteHf > 0)) return 0;
  const wcp =
    num(op.walletCommissionPercent) ??
    num(tf.walletCommissionPercent) ??
    100;
  const pct = wcp < 0 || wcp > 100 ? 100 : wcp;
  return round2((absoluteHf * pct) / 100);
}
